module.exports = __webpack_public_path__ + "static/media/congrat-icon.4f306f6f.png";